import ApplicationFriendsPage from './ApplicationFriendsPage'

export default ApplicationFriendsPage